<template>
  <div ref="modal" class="modal fade" :class="modalClass" @click="hideModal($event, true)">
    <div class="modal-dialog" :class="sizeClass">
      <div class="modal-content" :class="customContentClass">
        <!-- Modal Header -->
        <div v-if="showHeader || showClose" class="modal-header">
          <slot name="header">
            <h4 v-if="title" :aria-level="ariaLevelOfTitle" class="modal-title">
              {{ title }}
            </h4>
          </slot>

          <button v-if="showClose" type="button" class="close" aria-label="Zamknięcie okienka" @click="hideModal">
            <span aria-hidden="true">
              &times;
            </span>
          </button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <slot />
        </div>

        <!-- Modal footer -->
        <div v-if="showFooter" class="modal-footer">
          <slot name="footer">
            <button v-if="showCloseButton" type="button" class="btn btn-danger" @click="hideModal">
              {{ closeButton }}
            </button>

            <button
              v-if="showSubmitButton"
              type="button"
              class="btn btn-primary"
              :disabled="disableSubmitButton"
              @click="submitModal"
            >
              {{ submitButton }}
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.show {
  display: block;
}

.modal-dialog.modal-fullscreen {
  width: 100vw !important;
  max-width: 100vw !important;
  margin: 0 !important;
}

.modal-dialog.modal-fullscreen > .modal-content {
  max-height: 100vh !important;
  height: 100vh !important;
}

.modal-dialog.modal-fullscreen .modal-header {
  padding-bottom: 0;
}

.modal-dialog.modal-fullscreen .modal-footer {
  padding-top: 0;
}
</style>

<script>
export default {
  name: 'WModal',
  mixins: [],
  props: {
    // "Wartość" - czy pokazać
    value: Boolean,
    // Czy ukrywać przy kliknięciu w overlay
    hideOnOverlay: { type: Boolean, default: true },
    // Czy ukrywać przy kliknięciu escape
    hideOnEsc: { type: Boolean, default: true },
    // Czy wyświetlać header
    showHeader: { type: Boolean, default: true },
    // Czy wyświetlać X do zamknięcia w rogu
    showClose: { type: Boolean, default: true },
    // Czy wyświetlać przycisk zamknięcia (button na dole)
    showCloseButton: { type: Boolean, default: true },
    // Czy wyświetlać footer
    showFooter: { type: Boolean, default: true },
    // Tytuł
    title: { type: String, default: '' },
    // Rozmiar
    size: { type: String, default: '' },
    // Tekst przycisku zamknięcia
    closeButton: { type: String, default: 'Close' },
    // Tekst Przycisku wysłania
    submitButton: { type: String, default: 'Ok' },
    // Czy pokazywać przycisk wysłania
    showSubmitButton: { type: Boolean, default: true },
    // Czy zamknąć przy wysłaniu
    closeOnSubmit: { type: Boolean, default: true },
    // Czy wyłączyć przycisk wysłania
    disableSubmitButton: { type: Boolean, default: false },
    // Klasa dla elementu z zawartością modala
    customContentClass: { type: String, default: '' },
    // Wartość atrybutu `aria-level` w title modala
    ariaLevelOfTitle: { type: Number, default: 2, required: false }
  },
  data() {
    return {
      sid: 'mod' + Math.round(Math.random() * 1000000),
      backdrop: undefined,
      showModal: false
    };
  },
  computed: {
    sizeClass() {
      if (this.size) {
        return 'modal-' + this.size;
      }
    },
    modalClass() {
      if (this.showModal) {
        return 'show';
      }
    }
  },
  watch: {
    hideOnEsc: {
      handler(next, prev) {
        if (next) {
          document.addEventListener('keyup', this.onKeyPress);
        } else {
          document.removeEventListener('keyup', this.onKeyPress);
        }
      },
      immediate: true
    },
    value(next, prev) {
      this.showModal = next;
    },
    showModal(next, prev) {
      if (next) {
        this.backdrop.style.display = 'block';
        this.toggleBodyClass('addClass', 'modal-open');

        setTimeout(() => {
          this.toggleClass(this.backdrop, 'addClass', 'show');
        }, 100);
      } else {
        this.toggleBodyClass('removeClass', 'modal-open');
        this.backdrop.style.display = 'none';

        setTimeout(() => {
          this.toggleClass(this.backdrop, 'removeClass', 'show');
        }, 100);
      }
    }
  },
  created() {
    this.showModal = this.value;

    this.backdrop = document.body.querySelector('.modal-backdrop');
    if (!this.backdrop) {
      this.backdrop = this.createBackdrop();
      this.attach(this.backdrop);
    }
  },
  beforeDestroy() {
    if (this.showModal) {
      this.toggleBodyClass('removeClass', 'modal-open');
      this.backdrop.style.display = 'none';
    }
    if (document.getElementsByClassName('modal').length === 0) {
      this.backdrop.remove();
    } else {
      document.removeEventListener('keyup', this.onKeyPress);
      this.toggleClass(this.backdrop, 'removeClass', 'show');
    }
  },
  mounted() {
    if (this.showModal) {
      this.toggleBodyClass('addClass', 'modal-open');
    }
  },
  methods: {
    onKeyPress(event) {
      if (event.keyCode === 27) {
        this.hideModal();
      }
    },
    createBackdrop() {
      const backdrop = document.createElement('div');
      backdrop.classList.add('modal-backdrop');
      backdrop.classList.add('fade');
      backdrop.style.display = 'none';
      return backdrop;
    },
    attach(element) {
      document.body.append(element);
    },
    hideModal($event, backdropClick) {
      if (backdropClick && !this.hideOnOverlay) {
        return;
      }
      if (backdropClick && $event.target !== this.$refs.modal) {
        return;
      }

      this.showModal = false;
      this.$emit('close');
    },
    submitModal($event) {
      if (this.closeOnSubmit) {
        this.showModal = false;
      }

      this.$emit('submit');
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      this.toggleClass(el, addRemoveClass, className);
    },
    toggleClass(element, addRemoveClass, className) {
      if (addRemoveClass === 'addClass') {
        element.classList.add(className);
      } else {
        element.classList.remove(className);
      }
    }
  }
};
</script>
